export default __webpack_public_path__ + "static/media/spark_37.7793a344.png";